export const dictionary: Record<string, Record<string, string>> = {
  name: {
    pt: "nome",
    en: "name",
  },
  year: {
    pt: "ano",
    en: "year",
  },
  month: {
    pt: "mês",
    en: "month",
  },
  version: {
    pt: "versão",
    en: "version",
  },
  status: {
    pt: "estado",
    en: "status",
  },
  actions: {
    pt: "ações",
    en: "actions",
  },
  "create employee": {
    pt: "Criar Colaborador",
    en: "Create Employee",
  },
  "edit employee": {
    pt: "Editar Colaborador",
    en: "Edit Employee",
  },
  "employees > create employee": {
    pt: "Colaboradores > Criar Colaborador",
    en: "Employees > Create Employee",
  },
  "employees > edit employee": {
    pt: "Colaboradores > Editar Colaborador",
    en: "Employees > Edit Employee",
  },
  employees: {
    pt: "colaboradores",
    en: "employees",
  },
  employee: {
    pt: "colaborador",
    en: "employee",
  },
  edit: {
    pt: "editar",
    en: "edit",
  },
  confirmation: {
    pt: "confirmação",
    en: "confirmation",
  },
  yes: {
    pt: "sim",
    en: "yes",
  },
  no: {
    pt: "não",
    en: "no",
  },
  create: {
    pt: "criar",
    en: "create",
  },
  new: {
    pt: "novo",
    en: "new",
  },
  clean: {
    pt: "limpar",
    en: "clean",
  },
  search: {
    pt: "procurar",
    en: "search",
  },
  number: {
    pt: "número",
    en: "number",
  },
  function: {
    pt: "função",
    en: "function",
  },
  contract: {
    pt: "contrato",
    en: "contract",
  },

  active: {
    pt: "ativo",
    en: "active",
  },
  "personal informations": {
    pt: "informações pessoais",
    en: "personal informations",
  },
  "professional informations": {
    pt: "informações profissionais",
    en: "professional informations",
  },
  "salary informations": {
    pt: "informações salariais",
    en: "salary informations",
  },
  "paid vacation": {
    pt: "Férias Pagas",
    en: "Paid vacation",
  },
  "paid vacation days": {
    pt: "Dias de Férias Pagos",
    en: "Paid vacation days",
  },
  documents: {
    pt: "documentos",
    en: "documents",
  },
  next: {
    pt: "próximo",
    en: "next",
  },
  save: {
    pt: "guardar",
    en: "save",
  },
  upload: {
    pt: "carregar",
    en: "upload",
  },
  "full name": {
    pt: "nome completo",
    en: "full name",
  },
  "birth date": {
    pt: "data de nascimento",
    en: "birth date",
  },
  "personal phone": {
    pt: "telefone pessoal",
    en: "personal phone",
  },
  "personal email": {
    pt: "e-mail pessoal",
    en: "personal email",
  },
  country: {
    pt: "país",
    en: "country",
  },
  "postal code": {
    pt: "código postal",
    en: "postal code",
  },
  city: {
    pt: "cidade",
    en: "city",
  },
  address: {
    pt: "morada",
    en: "address",
  },
  "address complement": {
    pt: "complemento da morada",
    en: "address complement",
  },
  "id document type": {
    pt: "tipo do documento de identificação",
    en: "id document type",
  },
  "id document number": {
    pt: "número do documento de identificação",
    en: "id document number",
  },
  "tax number": {
    pt: "número de contribuinte (NIF)",
    en: "tax number",
  },
  "social security number": {
    pt: "número da segurança social (NISS)",
    en: "social security number",
  },
  "driving licence": {
    pt: "carta de condução",
    en: "driving licence",
  },
  "bank account": {
    pt: "conta bancária (NIB)",
    en: "bank account",
  },
  "marital status": {
    pt: "estado civil",
    en: "marital status",
  },
  "number of children": {
    pt: "número de filhos",
    en: "number of children",
  },
  "number of dependents": {
    pt: "número de dependentes",
    en: "number of dependents",
  },
  "save employee first to add dependents": {
    pt: "salve o colaborador primeiro para adicionar dependentes",
    en: "save employee first to add dependents",
  },
  "manage dependents": {
    pt: "gerir dependentes",
    en: "manage dependents",
  },
  dependents: {
    pt: "dependentes",
    en: "dependents",
  },
  "add dependent": {
    pt: "adicionar dependente",
    en: "add dependent",
  },
  "no dependents found": {
    pt: "nenhum dependente encontrado",
    en: "no dependents found",
  },
  "fiscal id": {
    pt: "nif",
    en: "fiscal id",
  },
  "childhood check value": {
    pt: "valor abono de infância",
    en: "childhood check value",
  },
  "education check value": {
    pt: "valor abono de educação",
    en: "education check value",
  },
  "childhood check": {
    pt: "abono de infância",
    en: "childhood check",
  },
  "education check": {
    pt: "abono de educação",
    en: "education check",
  },
  "dependent created successfully": {
    pt: "dependente criado com sucesso",
    en: "dependent created successfully",
  },
  "dependent updated successfully": {
    pt: "dependente atualizado com sucesso",
    en: "dependent updated successfully",
  },
  "dependent deleted successfully": {
    pt: "dependente eliminado com sucesso",
    en: "dependent deleted successfully",
  },
  "are you sure you want to delete this dependent?": {
    pt: "tem certeza que deseja eliminar este dependente?",
    en: "are you sure you want to delete this dependent?",
  },
  "emergency contact name": {
    pt: "nome do contacto de emergência",
    en: "emergency contact name",
  },
  "relation to emergency contact": {
    pt: "relação com o contacto de emergência",
    en: "relation to emergency contact",
  },
  "emergency contact": {
    pt: "contacto de emergência",
    en: "emergency contact",
  },
  "contract type": {
    pt: "tipo de contrato",
    en: "contract type",
  },

  "Contract Type": {
    pt: "Tipo de Contrato",
    en: "Contract Type",
  },
  "employee number": {
    pt: "número de colaborador",
    en: "employee number",
  },
  "professional email": {
    pt: "e-mail profissional",
    en: "professional email",
  },
  "professional phone": {
    pt: "telefone profissional",
    en: "professional phone",
  },
  manager: {
    pt: "manager",
    en: "manager",
  },
  "work country": {
    pt: "país de trabalho",
    en: "work country",
  },
  "work city": {
    pt: "cidade de trabalho",
    en: "work city",
  },
  "function type": {
    pt: "tipo de função",
    en: "function type",
  },
  "last year vacation days": {
    pt: "dias de férias do ano anterior",
    en: "last year vacation days",
  },
  "current year vacation days": {
    pt: "dias de férias do ano atual",
    en: "current year vacation days",
  },
  "expiry date rfi": {
    pt: "data de validade RFI",
    en: "expiry date RFI",
  },
  "vehicle number plate": {
    pt: "matrícula da viatura",
    en: "vehicle number plate",
  },
  "responsible for the vehicle": {
    pt: "responsável pela viatura",
    en: "responsible for the vehicle",
  },
  "admission date": {
    pt: "data de admissão",
    en: "admission date",
  },
  "contract cancellation date": {
    pt: "data de rescisão",
    en: "contract cancellation date",
  },
  observations: {
    pt: "observações",
    en: "observations",
  },
  view: {
    pt: "visualizar",
    en: "view",
  },
  remove: {
    pt: "remover",
    en: "remove",
  },
  settings: {
    pt: "configurações",
    en: "settings",
  },
  trips: {
    pt: "viagens",
    en: "trips",
  },
  vacations: {
    pt: "Férias",
    en: "Vacation",
  },
  "schedule vacation": {
    pt: "agendar férias",
    en: "schedule vacation",
  },
  "vacation list": {
    pt: "lista férias",
    en: "vacation list",
  },
  "start date": {
    pt: "data de início",
    en: "start date",
  },
  "end date": {
    pt: "data de fim",
    en: "end date",
  },
  schedule: {
    pt: "agendar",
    en: "schedule",
  },
  "expense date": {
    pt: "Data da despesa",
    en: "Expense Date",
  },
  "expense type": {
    pt: "Tipo de despesa",
    en: "Expense Type",
  },
  "value": {
    pt: "Valor",
    en: "Value",
  },
  "monthly amount": {
    pt: "valor mensal",
    en: "monthly amount",
  },
  "yearly amount": {
    pt: "valor anual",
    en: "yearly amount",
  },
  "proof of activity or company": {
    pt: "comprovativo de atividade ou empresa",
    en: "proof of activity or company",
  },
  "criminal record": {
    pt: "registo criminal",
    en: "criminal record",
  },
  "id document": {
    pt: "documento de identificação",
    en: "id document",
  },
  "tax residence certificate (rfi)": {
    pt: "certificado de residência fiscal (RFI)",
    en: "tax residence certificate (RFI)",
  },
  "declaration of no debt to the tax office": {
    pt: "declaração de não dívidas às finanças",
    en: "declaration of no debt to the tax office",
  },
  "cirs proof": {
    pt: "certificado CIRS",
    en: "CIRS proof",
  },
  "signed nimber contract": {
    pt: "contrato assinado com a Nimber",
    en: "signed Nimber contract",
  },
  "iban proof": {
    pt: "Comprovativo IBAN",
    en: "IBAN proof",
  },
  "certificate of qualifications": {
    pt: "certificado de habilitações",
    en: "certificate of qualifications",
  },
  "proof of address": {
    pt: "comprovativo de morada",
    en: "proof of address",
  },
  "support service": {
    pt: "serviço de suporte",
    en: "support service",
  },
  "gross base value": {
    pt: "Valor Base Bruto",
    en: "Gross Base Value",
  },
  "food allowance value": {
    pt: "Valor do Subsídio de Alimentação",
    en: "Food Allowance Value",
  },
  "costs allowance value": {
    pt: "Valor de Ajudas de Custo",
    en: "Costs Allowance Value",
  },
  "una bonus value": {
    pt: "Valor do Bónus UNA",
    en: "UNA Bonus Value",
  },
  "education check total value": {
    pt: "Valor Total do Cheque Educação",
    en: "Education Check Total Value",
  },
  "childhood check total value": {
    pt: "Valor Total do Cheque Infância",
    en: "Childhood Check Total Value",
  },
  "training value": {
    pt: "Valor da Formação",
    en: "Training Value",
  },
  "iht value": {
    pt: "Valor do IHT",
    en: "IHT Value",
  },
  "irs type": {
    pt: "Tipo de IRS",
    en: "IRS Type",
  },
  "irs percentage": {
    pt: "Percentagem de IRS",
    en: "IRS Percentage",
  },
  "daily value": {
    pt: "Valor Diário",
    en: "Daily Value",
  },
  "absence approved days": {
    pt: "Dias de Ausência Aprovados",
    en: "Absence Approved Days",
  },

  "remote worker": {
    pt: "trabalhador remoto",
    en: "remote worker",
  },
  "document type": {
    pt: "tipo de documento",
    en: "document type",
  },
  "Already exists {entityName} {value} of type {type}.": {
    pt: "Já existe {entityName} {value} do tipo {type}.",
    en: "Already exists {entityName} {value} of type {type}.",
  },
  "Invalid [{param}] {paramName} in {entity}.": {
    pt: "{paramName} [{param}] inválido em {entity}.",
    en: "Invalid [{param}] {paramName} in {entity}.",
  },
  "Already exists {paramName} {param} in {entity}.": {
    pt: "Já existe {entity} com {paramName} {param}.",
    en: "Already exists {entity} with {paramName} {param}.",
  },
  "Manager id {param} not found.": {
    pt: "Id de manager {param} não encontrado.",
    en: "Manager id {param} not found.",
  },
  "Employee {param} cannot manage people.": {
    pt: "Colaborador {param} não pode gerir outros colaboradores.",
    en: "Employee {param} cannot manage people.",
  },
  "{entity} id {param} not found.": {
    pt: "Id {param} de {entity} não encontrado.",
    en: "{entity} id {param} not found.",
  },
  "Employee named {employeeName} not {method} because location {workLocation} in {workCountry} does not exist in our system. It has to have holidays for that location first.":
  {
    pt: "O colaborador {employeeName} não foi {method} porque {workLocation} em {workCountry} não existe no sistema. Têm de existir feriados para essa localidade primeiro.",
    en: "Employee named {employeeName} not {method} because location {workLocation} in {workCountry} does not exist in our system. It has to have holidays for that location first.",
  },
  "{entity} for {param} not created.": {
    pt: "{entity} {param} não criado.",
    en: "{entity} for {param} not created.",
  },
  "{entity} {param} not deleted.": {
    pt: "{entity} {param} não eliminado.",
    en: "{entity} {param} not deleted.",
  },
  "{entity} not found by filter.": {
    pt: "{entity} não encontrado através de filtro.",
    en: "{entity} not found by filter.",
  },
  "Employee cannot be manager of himself.": {
    pt: "Um colaborador não pode ser manager de si próprio.",
    en: "Employee cannot be manager of himself.",
  },
  "{entity} {param} not updated.": {
    pt: "{entity} {param} não atualizado.",
    en: "{entity} {param} not updated.",
  },
  "CTI/CTP contractType must have vacationDaysCurrentYear, vacationDaysLastYear, carOwner, and carRegistration.":
  {
    pt: "O contractType CTI/CTP tem de ter vacationDaysCurrentYear, vacationDaysLastYear, carOwner, and carRegistration.",
    en: "CTI/CTP contractType must have vacationDaysCurrentYear, vacationDaysLastYear, carOwner, and carRegistration.",
  },
  "Only CTI/CTP contractType can have vacationDaysCurrentYear, vacationDaysLastYear, carOwner, and carRegistration.":
  {
    pt: "Apenas o contractType CTI/CTP pode ter vacationDaysCurrentYear, vacationDaysLastYear, carOwner, and carRegistration.",
    en: "Only CTI/CTP contractType can have vacationDaysCurrentYear, vacationDaysLastYear, carOwner, and carRegistration.",
  },
  "CPS Internacional contractType must have rfiExpiresAt.": {
    pt: "O contractType CPS Internacional tem de ter rfiExpiresAt.",
    en: "CPS Internacional contractType must have rfiExpiresAt.",
  },
  "Only CPS Internacional contractType can have rfiExpiresAt.": {
    pt: "Apenas o contractType CPS Internacional pode ter rfiExpiresAt.",
    en: "Only CPS Internacional contractType can have rfiExpiresAt.",
  },
  "Employee successfully registered": {
    pt: "Colaborador registado com sucesso",
    en: "Employee successfully registered.",
  },
  "Employee successfully updated": {
    pt: "Colaborador atualizado com sucesso",
    en: "Employee successfully updated.",
  },
  "receives iva": {
    pt: "Recebe IVA",
    en: "Receives IVA",
  },
  "support prevention value": {
    pt: "Valor do Apoio à Prevenção",
    en: "Support Prevention Value",
  },
  "{param}: String must contain at least 1 character(s)": {
    pt: "{param}: Tem de conter pelo menos 1 caracter.",
    en: "{param}: String must contain at least 1 character(s)",
  },
  "There are fields that must be filled in.": {
    pt: "Existem campos que têm que estar preenchidos.",
    en: "There are fields that must be filled in.",
  },
  "{param}: Invalid email": {
    pt: "{param} inválido.",
    en: "Invalid {param}.",
  },
  "{param},{param2}: Invalid uuid": {
    pt: "{param2} de {param} inválido.",
    en: "{param} {param2} invalid.",
  },
  "{param}: Invalid enum value. Expected {expected}, received {received}": {
    pt: "{param} inválido. O sistema espera {expected}, mas recebeu {received}.",
    en: "Invalid {param}. The system expects {expected}, but received {received}.",
  },
};

export const patterns = [
  // DUPLICATED_TYPE_VALUE
  {
    pattern: /Already exists ([^ ]+) ([^ ]+) of type ([^ ]+)\./,
    key: "Already exists {entityName} {value} of type {type}.",
    vars: ["entityName", "value", "type"],
  },
  // INVALID_VALUE
  {
    pattern: /Invalid \[([^ ]+)\] ([^ ]+) in ([^ ]+)\./,
    key: "Invalid [{param}] {paramName} in {entity}.",
    vars: ["param", "paramName", "entity"],
  },
  // DUPLICATED_ENTITY_FOR
  {
    pattern: /Already exists ([^ ]+) ([^ ]+) in ([^ ]+)\./,
    key: "Already exists {paramName} {param} in {entity}.",
    vars: ["paramName", "param", "entity"],
  },
  // MANAGER_NOT_FOUND
  {
    pattern: /Manager id ([^ ]+) not found\./,
    key: "Manager id {param} not found.",
    vars: ["param"],
  },
  // EMPLOYEE_NOT_PEOPLE_MANAGER
  {
    pattern: /Employee ([^ ]+) cannot manage people\./,
    key: "Employee {param} cannot manage people.",
    vars: ["param"],
  },
  // ID_NOT_FOUND
  {
    pattern: /([^ ]+) id ([^ ]+) not found\./,
    key: "{entity} id {param} not found.",
    vars: ["entity", "param"],
  },
  // EMPLOYEE_INVALID_WORK_LOCATION
  {
    pattern:
      /Employee named ([^ ]+) not ([^ ]+) because location (.+?) in ([^ ]+) does not exist in our system. It has to have holidays for that location first\./,
    key: "Employee named {employeeName} not {method} because location {workLocation} in {workCountry} does not exist in our system. It has to have holidays for that location first.",
    vars: ["employeeName", "method", "workLocation", "workCountry"],
  },
  // CREATION_FAILED_FOR
  {
    pattern: /([^ ]+) for ([^ ]+) not created\./,
    key: "{entity} for {param} not created.",
    vars: ["entity", "param"],
  },
  // DELETE_FAILED
  {
    pattern: /([^ ]+) ([^ ]+) not deleted\./,
    key: "{entity} {param} not deleted.",
    vars: ["entity", "param"],
  },
  // LIST_NOT_FOUND_BY_FILTER
  {
    pattern: /([^ ]+) not found by filter\./,
    key: "{entity} not found by filter.",
    vars: ["entity"],
  },
  // EMPLOYEE_MANAGER_HIMSELF
  {
    pattern: /Employee cannot be manager of himself\./,
    key: "Employee cannot be manager of himself.",
    vars: [],
  },
  // UPDATE_FAILED
  {
    pattern: /([^ ]+) ([^ ]+) not updated\./,
    key: "{entity} {param} not updated.",
    vars: ["entity", "param"],
  },
  // RULE
  {
    pattern:
      /CTI\/CTP contractType must have vacationDaysCurrentYear, vacationDaysLastYear, carOwner, and carRegistration\./,
    key: "CTI/CTP contractType must have vacationDaysCurrentYear, vacationDaysLastYear, carOwner, and carRegistration.",
    vars: [],
  },
  // RULE
  {
    pattern:
      /Only CTI\/CTP contractType can have vacationDaysCurrentYear, vacationDaysLastYear, carOwner, and carRegistration\./,
    key: "Only CTI/CTP contractType can have vacationDaysCurrentYear, vacationDaysLastYear, carOwner, and carRegistration.",
    vars: [],
  },
  // RULE
  {
    pattern: /CPS Internacional contractType must have rfiExpiresAt\./,
    key: "CPS Internacional contractType must have rfiExpiresAt.",
    vars: [],
  },
  // RULE
  {
    pattern: /Only CPS Internacional contractType can have rfiExpiresAt\./,
    key: "Only CPS Internacional contractType can have rfiExpiresAt.",
    vars: [],
  },
  // SUCCESS
  {
    pattern: /Employee successfully registered/,
    key: "Employee successfully registered",
    vars: [],
  },
  // SUCCESS
  {
    pattern: /Employee successfully updated/,
    key: "Employee successfully updated",
    vars: [],
  },
  // CONFIRMATION
  {
    pattern: /are you sure you want to delete this dependent\?/i,
    key: "are you sure you want to delete this dependent?",
    vars: [],
  },
  // ZOD STRING.MIN(1)
  {
    pattern: /There are fields that must be filled in\./,
    key: "There are fields that must be filled in.",
    vars: [],
  },
  // ZOD INVALID EMAIL
  {
    pattern: /([^ ]+): Invalid email/,
    key: "{param}: Invalid email",
    vars: ["param"],
  },
  {
    pattern: /([^ ]+),([^ ]+): Invalid uuid/,
    key: "{param},{param2}: Invalid uuid",
    vars: ["param", "param2"],
  },
  {
    pattern: /([^ ]+): Invalid enum value\. Expected (.*), received (.*)/,
    key: "{param}: Invalid enum value. Expected {expected}, received {received}",
    vars: ["param", "expected", "received"],
  },
];

// Salary validation errors
dictionary["iht cannot be applied due to the current gross base value."] = {
  pt: "IHT não pode ser aplicado devido ao valor base bruto atual.",
  en: "IHT cannot be applied due to the current gross base value.",
};

dictionary["daily value, abscence approved days and receives iva are not applicable for cti and ctp employees."] = {
  pt: "Valor diário, dias de ausência aprovados e recebe IVA não são aplicáveis para funcionários CTI e CTP.",
  en: "Daily Value, Abscence Approved Days and Receives IVA are not applicable for CTI and CTP employees.",
};

dictionary["gross base value, food allowance value and irs type are mandatory for cti and ctp employees."] = {
  pt: "Valor base bruto, subsídio de alimentação e tipo de IRS são obrigatórios para funcionários CTI e CTP.",
  en: "Gross Base Value, Food Allowance Value and IRS Type are mandatory for CTI and CTP employees.",
};

dictionary["costs allowance value cannot be applied without a valid driving licence document."] = {
  pt: "Ajudas de custo não podem ser aplicadas sem um documento de carta de condução válido.",
  en: "Costs Allowance value cannot be applied without a valid Driving Licence document.",
};

dictionary["irs percentage must be greater than zero for irs jovem type."] = {
  pt: "Percentagem de IRS deve ser maior que zero para o tipo IRS Jovem.",
  en: "IRS Percentage must be greater than zero for IRS Jovem type.",
};

dictionary["education and childhood check values cannot be applied without dependent children."] = {
  pt: "Valores de abono de família para educação e infância não podem ser aplicados sem filhos dependentes.",
  en: "Education and Childhood Check values cannot be applied without dependent children.",
};

dictionary["gross base value and food allowance value are not applicable for cps employees."] = {
  pt: "Valor base bruto e subsídio de alimentação não são aplicáveis para funcionários CPS.",
  en: "Gross Base Value and Food Allowance Value are not applicable for CPS employees.",
};

dictionary["daily value must be greater than zero for cps employees."] = {
  pt: "Valor diário deve ser maior que zero para funcionários CPS.",
  en: "Daily value must be greater than zero for CPS employees.",
};

dictionary["cps internacional employees do not pay iva."] = {
  pt: "Funcionários CPS Internacional não pagam IVA.",
  en: "CPS Internacional employees do not pay IVA.",
};

dictionary["description"] = {
  pt: "descrição",
  en: "description",
};

dictionary["cost allowance"] = {
  pt: "Ajudas de Custo",
  en: "Cost Allowance",
};

dictionary["requires driving license"] = {
  pt: "Requer carta de condução",
  en: "Requires driving license",
};

dictionary["set yes in driving license field (personal information)"] = {
  pt: "Defina \"Sim\" no campo Carta de Condução (Informações Pessoais)",
  en: "Set \"Yes\" in Driving License field (Personal Information)",
};

dictionary["food allowance"] = {
  pt: "Subsídio de Alimentação",
  en: "Food Allowance",
};

dictionary["paid via meal card"] = {
  pt: "Pago através de cartão refeição",
  en: "Paid via meal card",
};

dictionary["for children under 7 years"] = {
  pt: "Para crianças <7 anos",
  en: "For children under 7 years",
};

dictionary["for children 7 years or older"] = {
  pt: "Para crianças ≥7 anos",
  en: "For children 7 years or older",
};

dictionary["not editable here"] = {
  pt: "Não editável aqui",
  en: "Not editable here",
};

dictionary["values set in dependents tab"] = {
  pt: "Valores definidos na tab Dependentes",
  en: "Values set in Dependents tab",
};

dictionary["migrates to education check at 7 years"] = {
  pt: "Migra para Cheque Educação aos 7 anos",
  en: "Migrates to Education Check at 7 years",
};

dictionary["requires registered children"] = {
  pt: "Requer ter filhos registados",
  en: "Requires registered children",
};

dictionary["add dependents in dependents tab"] = {
  pt: "Adicione dependentes na tab Dependentes",
  en: "Add dependents in Dependents tab",
};

dictionary["review annually plus monthly adjustments"] = {
  pt: "Revisar anualmente + ajustes mensais",
  en: "Review annually plus monthly adjustments",
};

dictionary["training"] = {
  pt: "Formação",
  en: "Training",
};

dictionary["training must be approved by nimber who will also pay and send access"] = {
  pt: "A formação deve ser aprovada pela Nimber que irá também pagar a mesma e posteriormente enviar os acessos para a formação",
  en: "Training must be approved by Nimber who will also pay and send access",
};

dictionary["this value is not paid to the employee"] = {
  pt: "Este valor não é pago ao colaborador",
  en: "This value is not paid to the employee",
};

dictionary["iht (housing and work tax)"] = {
  pt: "IHT (Imposto sobre Habitação e Trabalho)",
  en: "IHT (Housing and Work Tax)",
};

dictionary["only applicable if gross base exceeds 870€"] = {
  pt: "Só aplicável se Base Bruto superior a 870€",
  en: "Only applicable if Gross Base exceeds 870€",
};

dictionary["automatic vat"] = {
  pt: "IVA Automático",
  en: "Automatic VAT",
};

dictionary["vat calculated automatically"] = {
  pt: "IVA calculado automaticamente",
  en: "VAT calculated automatically",
};

dictionary["fixed legal percentage applied on daily value"] = {
  pt: "% fixa legal aplicada sobre o valor dia",
  en: "Fixed legal percentage applied on daily value",
};

dictionary["prevention support"] = {
  pt: "Apoio à Prevenção",
  en: "Prevention Support",
};

dictionary["field only available for support employees"] = {
  pt: "Campo disponível apenas para colaboradores de suporte",
  en: "Field only available for support employees",
};

dictionary["review annually (dec/jan) to confirm eligibility and update percentage"] = {
  pt: "Revisar anualmente (Dez/Jan) para confirmar elegibilidade e atualizar percentagem.",
  en: "Review annually (Dec/Jan) to confirm eligibility and update percentage.",
};

// ZOD STRING.MIN(1)
export const emptyFieldsError =
  /([^ ]+): String must contain at least 1 character\(s\)$/;

export const emptyFieldsError2 = /([^ ]+): Attribute \1 is required$/;

export const emptyFieldsError3 =
  /([^ ]+): Invalid enum value\. Expected (.*), received ''/;

// export const outRangeMinNumberError = /([^ ]+): Number must be greater than or equal to ([^ ]+)/;
